module.exports = __webpack_public_path__ + "img/red_box.334d45dd.png";